import React from "react";
import { Link } from "react-router-dom";
import {BiDonateHeart} from 'react-icons/bi'

export default class DonateCta extends React.Component {
  render() {
    return (
      <>
        <section className="cta-one" style={{ padding: "40px 0" }}>
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="cta-one__inner">
                  <div className="cta-one__left">
                    <div className="cta-one__icon">
                      <BiDonateHeart />
                    </div>
                    <h2 className="cta-one__title">
                      Want to support our Heroes <br /> of Tomorrow project ?
                    </h2>
                  </div>
                  <div className="cta-one__right">
                    <Link
                      to={process.env.PUBLIC_URL + `/donate-now#now`}
                      className="thm-btn cta-one__btn"
                    >
                      Donate here
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
